import MarkdownRenderer from '../Markdown/MarkdownRenderer';

const LegalNoticeContentFromMarkdown = () => {
  
  return (
    <div className="legal-content-markdown pr-12 pl-12">
      <MarkdownRenderer file="/content/legal-notice.md" />
    </div>
  );
};

export default LegalNoticeContentFromMarkdown;
